export const companyNetworkErrorCodes = {
  ALREADY_EXISTS: "ALREADY_EXISTS",
  NOT_FOUND: "NOT_FOUND",
};

export const companyRoleErrorCodes = {
  COMPANY_ROLE_IN_USE: "COMPANY_ROLE_IN_USE",
};
